import React from 'react';

import '../../style/mailverified.css'; // We'll define the styles here

import iconExclaimation from "../../images/icon-exclamation.png";
const SessionLogout = () => {
    return (
        <div className="mail-verified-container">
            <div className="mail-verified-card">
            <figure>
              <img src={iconExclaimation} alt="Icon" />
            </figure>
                <p>You are Logout form Other Browser. </p>
                <p>Hold On! </p>
                <p>We Redirecting to Login Page.</p>
             </div>
        </div>
    );
};

export default SessionLogout;
